/**
 * Auth module for Vuex store
 */
import AuthService from '@/services/AuthService';

export default {
  namespaced: true,
  
  state: {
    user: null,
    userID: '',
    isSuperAdmin: false,
    loginError: null,
  },
  
  getters: {
    user: state => state.user,
    userID: state => state.userID,
    isSuperAdmin: state => state.isSuperAdmin,
    isLoggedIn: state => state.user !== null,
    loginError: state => state.loginError,
  },
  
  mutations: {
    SET_USER(state, user) {
      state.user = user;
    },
    SET_USER_ID(state, userID) {
      state.userID = userID;
    },
    SET_IS_SUPER_ADMIN(state, isSuperAdmin) {
      state.isSuperAdmin = isSuperAdmin;
    },
    SET_LOGIN_ERROR(state, error) {
      state.loginError = error;
    },
  },
  
  actions: {
    async login({ commit }, { email, password }) {
      try {
        const { user, uid } = await AuthService.login(email, password);
        commit('SET_USER', user);
        commit('SET_USER_ID', uid);
        commit('SET_LOGIN_ERROR', null);
        return user;
      } catch (error) {
        commit('SET_USER', null);
        commit('SET_USER_ID', null);
        commit('SET_LOGIN_ERROR', error.message || "Wrong email or password.");
        throw error;
      }
    },
    
    async logout({ commit, dispatch, rootGetters }) {
      try {
        // Exit video mode before logout (video mode requires login)
        if (rootGetters['ui/isVideoMode']) {
          await dispatch('ui/toggleVideoMode', null, { root: true });
        }

        await AuthService.logout();
        commit('SET_USER', null);
        commit('SET_USER_ID', null);
        await dispatch('playlist/resetPlaylist', null, { root: true });
        await dispatch('playlist/loadDefaultPlaylist', null, { root: true });
        return true;
      } catch (error) {
        console.error('Error logging out:', error);
        throw error;
      }
    },
    
    setUserFromAuth({ commit }, user) {
      if (user) {
        commit('SET_USER', user);
        commit('SET_USER_ID', user.uid);
      } else {
        commit('SET_USER', null);
        commit('SET_USER_ID', null);
        commit('SET_IS_SUPER_ADMIN', false);
      }
    },
  }
};